import { TAdInfo, TAdIsLat, TDeviceInfo } from '../types'
import { encodeObjectValues } from './encodeObjectValues'
import { getDeviceAdId } from './getDeviceAdId'

export const getXboxAdInfo = (baseDeviceInfo: TDeviceInfo): TAdInfo => {
  const adInfo: TAdInfo = {
    did: baseDeviceInfo.advertisingId ?? getDeviceAdId(),
    is_lat: baseDeviceInfo.isLAT ? TAdIsLat.TRUE : TAdIsLat.FALSE,
    // encode these values, else playback will fail on xbox's /video page
    // The note above is from old code and might not apply to webview2
    platform: 'Windows', // always Windows
    device_make: 'Microsoft', // always Microsoft
    device_model: baseDeviceInfo.deviceModel ?? 'unknown',
    osversion: '10.0', // always 10.0 (Windows NT 10.0)
  }
  return encodeObjectValues(adInfo)
}
